import { Box, Chip, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import { TopOrganization } from '../../types/apiRequests'
import { border } from '../../layout/theme/border'
import { formatCompact } from '../../utils/formatNumber'
import { fadeSlideIn } from './animations'

export const TopOrganizationsList: FC<{
  title: string
  items: TopOrganization[]
  accent: string
  delay: number
}> = ({ title, items, accent, delay }) => {
  const navigate = useNavigate()
  const translate = useTranslate()

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: border.card.radius,
        border: '1px solid rgba(0,0,0,0.06)',
        animation: `${fadeSlideIn} 0.5s ease-out ${delay}ms both`,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ px: 2.5, py: 2, borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: 'rgba(0,0,0,0.3)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}
        >
          {title}
        </Typography>
      </Box>
      {items.length === 0 ? (
        <Box sx={{ px: 2.5, py: 3, textAlign: 'center' }}>
          <Typography sx={{ fontSize: 13, color: 'rgba(0,0,0,0.25)' }}>
            {translate('dashboard.noData')}
          </Typography>
        </Box>
      ) : (
        items.map((item, i) => (
          <Box
            key={item.organization_id}
            onClick={() => navigate(`/organization/${item.organization_id}/show`)}
            sx={{
              'px': 2.5,
              'py': 1.5,
              'display': 'flex',
              'alignItems': 'center',
              'justifyContent': 'space-between',
              'gap': 2,
              'cursor': 'pointer',
              'borderBottom':
                i < items.length - 1 ? '1px solid rgba(0,0,0,0.03)' : 'none',
              'transition': 'background 0.15s',
              '&:hover': { background: 'rgba(0,0,0,0.015)' },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#1a1a1a',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.organization_name}
              </Typography>
            </Box>
            <Chip
              label={`${formatCompact(item.total_count)} calls`}
              size="small"
              sx={{
                fontWeight: 700,
                fontSize: 11,
                height: 22,
                border: 'none',
                bgcolor: `${accent}10`,
                color: accent,
                flexShrink: 0,
              }}
            />
          </Box>
        ))
      )}
    </Box>
  )
}
